import React from 'react';
import { gql } from '@apollo/client';
import { AutoImportersController } from './AutoImporters.controller';

gql`
  query GetAutoImports($workspaceId: ID!) {
    workspace(workspaceId: $workspaceId) {
      id
      socialProfiles {
        ...SocialProfileFields
        ... on PinterestSocialProfile {
          boards {
            ...CorePinterestBoardFields
          }
        }
      }
      categories {
        ...CategoryFields
      }
      autoImports {
        ...AutoImportFields
        category {
          ...CategoryFields
        }
        socialProfiles {
          ...SocialProfileFields
          ... on PinterestSocialProfile {
            boards {
              ...CorePinterestBoardFields
            }
          }
        }
      }
    }
  }
`;

export const AutoImportersApollo = (): JSX.Element => {
  return <AutoImportersController />;
};
